import { ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncSubject } from 'rxjs';
import * as Highcharts from 'highcharts/highmaps';

export class MapChart {
  public refSubject: AsyncSubject<any> = new AsyncSubject();
  public ref$: Observable<any> = this.refSubject.asObservable();
  public ref: any;

  public constructor(private options: any) { }

  public init(el: ElementRef): void {
    Highcharts.mapChart(el.nativeElement, this.options, (chart: any) => {
      this.refSubject.next(chart);
      this.ref = chart;
      this.refSubject.complete();
    });
  }

  public destroy(): void {
    if (this.ref) {
      this.options = this.ref.options;
      this.ref.destroy();
      this.ref = undefined;

      this.refSubject = new AsyncSubject();
      this.ref$ = this.refSubject.asObservable();
    }
  }
}
